// @flow
import styles from './LinkSelect.less';

import React, { Component } from 'react';
import { ChevronIcon, Strong } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

import filter from 'lodash/filter';
import get from 'lodash/get';
import toLower from 'lodash/toLower';

export type Option = {|
  value: string,
  label: string,
  isActive?: boolean,
  refineParams?: SearchParams & { where?: string }
|};

type Props = {
  id: string,
  label: string,
  options: Array<Option>,
  onChange?: Function
};

export default class LinkSelect extends Component<Props> {
  props: Props;
  checkbox: any;

  storeCheckboxReference = (checkbox: any): void => {
    if (checkbox !== null) {
      this.checkbox = checkbox;
    }
  };

  toggleCheckbox = () => {
    this.checkbox.checked = !this.checkbox.checked;
  };

  valueChanged = () => {
    if (this.props.onChange) {
      this.props.onChange();
    }
    this.toggleCheckbox();
  };

  renderSingleOption({
    label,
    activeLabel
  }: {
    label: string,
    activeLabel: string
  }) {
    return (
      <div className={`${styles.label} ${styles.label_isInactive}`}>
        {`${label} `}
        <Strong>{activeLabel}</Strong>
      </div>
    );
  }

  renderMultiOptions({
    id,
    label,
    options,
    activeLabel
  }: {
    id: string,
    label: string,
    options: Array<Option>,
    activeLabel: string
  }) {
    return (
      <div>
        <input
          aria-hidden="true"
          type="checkbox"
          id={id}
          className={styles.checkbox}
          ref={this.storeCheckboxReference}
        />
        <label id="SortedByLabel" htmlFor={id} className={styles.label}>
          {`${label} `}
          <Strong>{`${activeLabel} `}</Strong>
          <ChevronIcon
            small
            direction="down"
            svgClassName={styles.chevronSvg}
          />
        </label>
        <label htmlFor={id} className={styles.backdrop}>
          Done
        </label>
        <ul role="navigation" aria-label="Sort By" className={styles.options}>
          {options.map(({ value, label: optionLabel, refineParams }) => (
            <li key={value}>
              {refineParams ? (
                <NavLink
                  className={styles.option}
                  location={{
                    pathname: '/jobs',
                    query: refineParams
                  }}
                  aria-label={`Sort by ${optionLabel}`}
                  onClick={this.valueChanged}
                >
                  {optionLabel}
                </NavLink>
              ) : (
                <span className={styles.option} onClick={this.toggleCheckbox}>
                  {optionLabel}
                </span>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  render() {
    const { id, label, options } = this.props;
    const activeOption = filter(options, 'isActive')[0];
    const activeLabel = toLower(get(activeOption, 'label'));

    const OptionsToRender = () => {
      if (!activeLabel) {
        return null;
      }

      return options.length === 1
        ? this.renderSingleOption({ label, activeLabel })
        : this.renderMultiOptions({ id, label, options, activeLabel });
    };

    return (
      <div
        aria-labelledby="SortedByLabel"
        role="contentinfo"
        id="sortby"
        className={styles.root}
      >
        <OptionsToRender />
      </div>
    );
  }
}
